import { z } from 'zod/v4';

export const StyleDocumentAiResultStatusSchema = z.enum([
  'AWAITING_REVIEW',
  'DONE',
]);

export type StyleDocumentAiResultStatusType = z.infer<
  typeof StyleDocumentAiResultStatusSchema
>;

export const STYLE_DOCUMENT_AI_RESULT_STATUS = {
  AWAITING_REVIEW: 'AWAITING_REVIEW',
  DONE: 'DONE',
} as const;
